import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bemGenerator } from '@prisjakt/ui-base';
import FacebookIcon from 'mdi-react/FacebookBoxIcon';
import TwitterIcon from 'mdi-react/TwitterBoxIcon';
import T from '@prisjakt/ui-translate';

import {
  AndroidIcon,
  AppsIcon,
  CompareIcon,
  ForumIcon,
  InfoIcon,
  IosIcon,
  ListsIcon,
  MinhembioIcon,
  PricefightIcon,
  ShopsIcon,
} from './components/icons';

import './footer.scss';

const styles = bemGenerator('legacy-footer', [
  'env-desktop',
  'env-mobile',
  'column-wrapper',
  'column',
  'bottom',
  'bottom-spacer',
  'social-media',
  'quick-links',
  'quick-link-title',
]);

class LegacyFooter extends React.Component {
  getCategories() {
    return this.props.data && this.props.data.categoryTree
      ? this.props.data.categoryTree
      : [];
  }

  getCampaigns() {
    return this.props.data && this.props.data.campaigns
      ? this.props.data.campaigns
      : [];
  }

  renderDesktop() {
    const { legacyUrls } = this.props;

    const categories = this.getCategories().map(item => (
      <li key={item.id} className={styles.column}>
        <h3>
          <a href={`${legacyUrls.category}?k=${item.id}`}>{item.name}</a>
        </h3>
        <ul>
          {item.children &&
            item.children.slice(0, 8).map(child => (
              <li key={child.id}>
                <a href={`${legacyUrls.category}?k=${child.id}`}>
                  {child.name}
                </a>
              </li>
            ))}
        </ul>
      </li>
    ));
    const campaigns = this.getCampaigns()
      .filter(campaign => Date.now() < parseInt(campaign.end, 10))
      .sort((a, b) => parseInt(a.start, 10) - parseInt(b.start, 10))
      .map(campaign => (
        <li key={campaign.id}>
          <a
            href={
              campaign.slug
                ? `${this.props.campaignBasePath}/${campaign.slug}`
                : campaign.web_uri.desktop
            }
          >
            {campaign.name ? campaign.name : campaign.title.short}
          </a>
        </li>
      ));

    return (
      <div className={styles['env-desktop']}>
        <ul className={styles['quick-links']}>
          <li>
            <a href={legacyUrls.lists}>
              <ListsIcon />
              <T domain="footer">link.lists</T>
            </a>
          </li>
          <li>
            <a href={`${legacyUrls.product}?j`}>
              <CompareIcon />
              <T domain="footer">link.compare</T>
            </a>
          </li>
          {legacyUrls.forum && (
            <li>
              <a href={legacyUrls.forum}>
                <ForumIcon />
                <T domain="footer">link.forum</T>
              </a>
            </li>
          )}
          <li>
            <a href={legacyUrls.store_info}>
              <ShopsIcon />
              <T domain="footer">link.shops</T>
            </a>
          </li>
          <li>
            <a href={legacyUrls.fight}>
              <PricefightIcon />
              <T domain="footer">link.price-fight</T>
            </a>
          </li>
          {legacyUrls.minhembio && (
            <li>
              <a href={legacyUrls.minhembio}>
                <MinhembioIcon />
                <T domain="footer">link.minhembio</T>
              </a>
            </li>
          )}
          <li>
            <a href={legacyUrls.info}>
              <InfoIcon />
              <T domain="footer">link.info</T>
            </a>
          </li>
          <li>
            <a href={legacyUrls.plugin}>
              <AppsIcon />
              <T domain="footer">link.plugins</T>
            </a>
          </li>
        </ul>
        <ul className={styles['column-wrapper']}>
          {categories}
          {!!campaigns.length && (
            <li className={styles.column} key="extra1">
              <h3>
                <a href={this.props.campaignBasePath}>
                  <T domain="campaigns">themes.title</T>
                </a>
              </h3>
              <ul>{campaigns}</ul>
            </li>
          )}
          <li className={styles.column} key="extra2">
            <h3>
              <a href={legacyUrls.category}>
                <T domain="footer">link.categories</T>
              </a>
            </h3>
            <p>
              <T domain="footer">link.categories-description</T>
            </p>
          </li>
          <li className={styles.column} key="extra3">
            <h3>
              <a href={legacyUrls.raw}>
                <T domain="footer">link.raw</T>
              </a>
            </h3>
            <p>
              <T domain="footer">link.raw-description</T>
            </p>
          </li>
          <li className={styles.column} key="empty1" />
          <li className={styles.column} key="empty2" />
          <li className={styles.column} key="empty3" />
          <li className={styles.column} key="empty4" />
          <li className={styles.column} key="empty5" />
        </ul>
        <div className={styles.bottom}>
          <p>
            <a href={legacyUrls.plugin}>
              <AndroidIcon />
              <T domain="footer">link.android-app</T>
            </a>
            <span className={styles['bottom-spacer']}>|</span>
            <a href={legacyUrls.plugin}>
              <IosIcon />
              <T domain="footer">link.ios-app</T>
            </a>
            <span className={styles['bottom-spacer']}>|</span>
            <a href={legacyUrls.mobile_site}>
              <AppsIcon />
              <T domain="footer">link.mobile-site</T>
            </a>
            <span className={styles['social-media']}>
              {legacyUrls.facebook && (
                <a
                  href={legacyUrls.facebook}
                  alt="Facebook"
                  target="_BLANK"
                  rel="noopener nofollow noreferrer"
                >
                  <FacebookIcon />
                </a>
              )}
              {legacyUrls.twitter && (
                <a
                  href={legacyUrls.twitter}
                  alt="Twitter"
                  target="_BLANK"
                  rel="noopener nofollow noreferrer"
                >
                  <TwitterIcon />
                </a>
              )}
            </span>
          </p>
          <p>
            <a href={`${legacyUrls.info}?t=about_company`}>
              <T domain="footer" year={new Date().getUTCFullYear()}>
                info.copyright
              </T>
            </a>
            <span className={styles['bottom-spacer']}>|</span>
            <a href={`${legacyUrls.info}?t=about_support`}>
              <T domain="footer">link.contact</T>
            </a>
            <span className={styles['bottom-spacer']}>|</span>
            <a href={`${legacyUrls.info}?t=about_price_comparison`}>
              <T domain="footer">link.about-price-comparison</T>
            </a>
            <span className={styles['bottom-spacer']}>|</span>
            <a href={`${legacyUrls.info}?t=about_cookies`}>
              <T domain="footer">link.about-cookies</T>
            </a>
          </p>
        </div>
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderMobile() {
    return (
      <div className={styles['env-mobile']}>
        <T domain="footer" year={new Date().getUTCFullYear()}>
          info.copyright
        </T>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.block}>
        {this.renderDesktop()}
        {this.renderMobile()}
      </div>
    );
  }
}

const { object, shape, arrayOf, string, number } = PropTypes;

LegacyFooter.propTypes = {
  campaignBasePath: string.isRequired,
  legacyUrls: object.isRequired, // eslint-disable-line react/forbid-prop-types
  data: shape({
    categoryTree: arrayOf(
      shape({
        name: string.isRequired,
        id: string.isRequired,
        children: arrayOf(
          shape({
            name: string.isRequired,
            id: string.isRequired,
          })
        ),
      })
    ),
    campaigns: arrayOf(
      shape({
        id: string.isRequired,
        name: string.isRequired,
        slug: string.isRequired,
        title: shape({
          short: string.isRequired,
        }),
        web_uri: shape({
          desktop: string.isRequired,
        }),
        start: number.isRequired,
        end: number.isRequired,
      })
    ),
  }),
};

LegacyFooter.defaultProps = {
  data: undefined,
};

export default connect(state => ({
  ...state.graphql,
  legacyUrls: state.areas.campaign.legacyUrls,
  campaignBasePath: state.areas.campaign.base,
}))(LegacyFooter);
